import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { Orgfield, Personfield } from 'app/main/pages/edit-template/edit-template.dto';

@Directive({
  selector: '[appDynamicClass]'
})
export class DynamicClassDirective implements OnChanges {
  @Input() key!: string;
  @Input() allFields: Orgfield[] | Personfield[] = []; // Pass the entire array of fields for context

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnChanges(): void {
    const dynamicClass = this.getDynamicClass();
    this.applyClass(dynamicClass);
  }

  private getDynamicClass(): string {
    const FULL_WIDTH = 'mb-1 m-0 col-md-12 col-xl-12 col-sm-12';
    const HALF_WIDTH = 'mb-1 m-0 col-md-6 col-xl-6 col-sm-12';
    const QUARTER_WIDTH = 'mb-1 m-0 col-md-3 col-xl-3 col-sm-12';

    const isFieldEnabled = (key: string) =>
      this.allFields.some((field: Orgfield | Personfield) => field.key === key && field.is_enable);

    const hasRegNo = isFieldEnabled('reg_no');
    const hasZipCode = isFieldEnabled('zip_code');
    const hasCity = isFieldEnabled('city');
    const hasPhoneNo = isFieldEnabled('phone_no');
    const hasEmail = isFieldEnabled('email');

    switch (this.key) {
      case 'first_name':
      case 'last_name':
        return HALF_WIDTH;

      case 'email':
        return hasPhoneNo ? HALF_WIDTH : FULL_WIDTH;

      case 'phone_no':
        return hasEmail ? HALF_WIDTH : FULL_WIDTH;

      case 'organization':
        return hasRegNo ? HALF_WIDTH : FULL_WIDTH;

      case 'address':
        return hasZipCode || hasCity ? HALF_WIDTH : FULL_WIDTH;

      case 'reg_no':
        return HALF_WIDTH;

      case 'zip_code':
        return hasCity ? QUARTER_WIDTH : HALF_WIDTH;

      case 'city':
        return hasZipCode ? QUARTER_WIDTH : HALF_WIDTH;

      default:
        return FULL_WIDTH;
    }
  }

  private applyClass(dynamicClass: string): void {
    const classes = dynamicClass.split(' ');
    this.renderer.removeAttribute(this.el.nativeElement, 'class'); // Reset existing classes
    classes.forEach(cls => this.renderer.addClass(this.el.nativeElement, cls));
  }
}
